import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { DocumentoMuestraLaboratorioSolicitudExViewModel, SolicitudLaboratorioExViewModel } from '../laboratorioEx.types';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-laboratorioex-documentos-list',
    templateUrl: './laboratorioex-documentos-list.component.html',
})
export class LaboratorioExDocumentosListComponent extends ComponentBase implements OnInit, OnChanges {
    public isCollapsedCabecera = false;

    cols: any[];
    numeroDocumentosEx = 0;

    @Input() idSolicitudEx: number;
    @Input() formGroup: FormGroup;
    @Input() solicitudLaboratorioEx: SolicitudLaboratorioExViewModel;
    @Input() esPerfilInspector = false;
    @Input() esPerfilConsultasyLaboratorio = false;
    @Input() hayEnvioMuestrasInspectorEx = false;
    @Input() hayResultadoMuestrasLaboratorioEx = false;
    @Input() envioMuestrasExCerrado = false;
    @Input() documentosLaboratorioEx: DocumentoMuestraLaboratorioSolicitudExViewModel[];
    @Output() downloadDoc = new EventEmitter<DocumentoMuestraLaboratorioSolicitudExViewModel>();
    @Output() removeDoc = new EventEmitter<DocumentoMuestraLaboratorioSolicitudExViewModel>();

    constructor(
        private router: Router,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'NombreArchivo', header: 'Nombre del archivo' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'Texto', header: 'Texto' },
        ];
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.documentosLaboratorioEx?.currentValue) {
            this.numeroDocumentosEx = this.documentosLaboratorioEx.length;
        }
    }

    onDownload(file: DocumentoMuestraLaboratorioSolicitudExViewModel) {
        this.downloadDoc.emit(file);
    }

    onEdit(rowData: DocumentoMuestraLaboratorioSolicitudExViewModel) {
        this.router.navigate([`/exportacion/solicitud/laboratorioEx/${this.idSolicitudEx}/documento/${rowData.Id}`]);
    }

    onRemove(rowData: DocumentoMuestraLaboratorioSolicitudExViewModel) {
        this.removeDoc.emit(rowData);
    }
}
